import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'modal-information-message',
  templateUrl: './modalInformationMessage.component.html',
  styleUrls: ['./modalInformationMessage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ModalInformationMessageComponent {
  data = inject<{
    text: string;
    icon: string;
  }>(MAT_DIALOG_DATA);
}
